<template>
  <div class="main-container">
    <div class="return" @click="goToPreviousPage()">
      <img src="@/assets/LeftWhite.svg" alt="left-caret icon" /> <span>{{ $t('legal.generalCondition.return') }}</span>
    </div>
    <div class="about-container">
      <language-selection class="language-selection"
                          @languageChange="changeLanguage"
                          :languages="languages"
                          :language="language"
      />
      <div class="wrapper">
        <div class="content">
          <div class="logo-container">
            <div class="cannect-logo">
              <img src="@/assets/CAnnectLogo.svg" alt="CAnnect" />
            </div>
          </div>
          <h1 class="title">
            Building Bridges &amp; Capitalising on Connections
          </h1>
          <read-about-fr :show-community-how-to="showCommunityHowTo"
                         @onGoToCommunity="goToHowTo"
                         v-if="language === 'fr'"
          />
          <read-about-en :show-community-how-to="showCommunityHowTo"
                         @onGoToCommunity="goToHowTo"
                         v-else
          />
          <div class="made-by">
            <span>Made by</span>
            <img src="@/assets/logo-innovation-lab.png" alt="logo innovation lab" />
          </div>
        </div>
        <div class="version">
          <span>Current version: {{ commitId }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from '../../config'
import LanguageSelection from './LanguageSelection'
import ReadAboutFr from './ReadAboutFr'
import ReadAboutEn from './ReadAboutEn'
import Utils from '../../utils'

export default {
  name: 'ReadAbout',
  components: { LanguageSelection, ReadAboutFr, ReadAboutEn },
  data() {
    return {
      languages: ['en', 'fr'],
      language: this.$i18n.locale,
      commitId: config.COMMIT_ID
    }
  },
  computed: {
    showCommunityHowTo() {
      return !Utils.isBlank(config.COMMUNITY_HOW_TO_ID)
    }
  },
  methods: {
    changeLanguage(language) {
      this.language = language
    },
    goToPreviousPage() {
      this.$router.go(-1)
    },
    goToHowTo() {
      if (config.COMMUNITY_HOW_TO_ID) {
        this.$router.push({ name: 'communityPage', params: { id: config.COMMUNITY_HOW_TO_ID } })
      }
    }
  }
}
</script>

<style scoped lang="scss" src="./Return.scss"></style>
<style scoped lang="scss">

@media only print {

  ::v-deep .locale-content {
    .content-box {
      box-shadow: none !important;
      padding: 0 2rem !important;
      margin: 0 auto !important;
    }
  }

  /* Fix for printing in Firefox */
  .content {
    display: block !important;
  }
}

@media not print {
  ::v-deep .locale-content {
    .print-only {
      display: none;
    }
  }
}

::v-deep .locale-content {
  text-align: left;
}

.main-container {
  margin: 0 0 1rem 0;
  z-index: 1;
  background-color: #F2F2F2;
  width: 100%;
  height: 100%;
  color: $black-color;
  @media (max-width: $medium) {
    margin-top: -20px;
  }
}

.about-container {
  width: 900px;
  max-width: 100vw;
  margin: 0 auto 30px auto;
  z-index: 0;

  .language-selection {
    z-index: 1;
    position: relative;
  }
}

.wrapper {
  width: 100%;
  background: #F2F2F2;;
  z-index: 2;
  position: relative;

  .content {
    background: white;
    box-shadow: 2px 7px 8px 0 rgba(69, 69, 69, 0.20);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-top: -5px;
    box-sizing: border-box;
    padding: 20px 100px 50px;
    @media (max-width: $small) {
      padding: 20px 20px 50px;
    }
  }

  .title {
    color: $primary-color;
    font-size: 24px;
    width: 100%;
    text-align: center;
    margin: 0 auto;
  }

  .logo-container {
    text-align: center;

    .cannect-logo {
      padding: 30px 0;
    }
  }
}

.version {
  display: flex;
  margin-top: 30px;
  justify-content: flex-start;
  span {
    color: #999999;
    font-size: 14px;
  }
}

.made-by {
  display: flex;
  cursor: pointer;
  margin-top: 30px;

  span {
    color: #999999;
    margin-right: 10px;
    font-size: 13px;
  }

  img {
    width: auto;
    height: 250px;
  }
}
</style>
